import { map } from 'lodash/fp';
import { OrderItem } from '@mews-commander/types';
import { SimpleList } from '@optimus-web/core';
import AdditionalExpensesListItem from './AdditionalExpensesListItem';

interface Props {
    additionalExpenses: OrderItem[];
    serviceId: string;
}

const AdditionalExpensesList = ({ additionalExpenses, serviceId }: Props) => (
    <SimpleList spacing="0" listStyle="none" plain>
        {map(
            (additionalExpense) => (
                <AdditionalExpensesListItem
                    additionalExpense={additionalExpense}
                    key={additionalExpense.id}
                    serviceId={serviceId}
                />
            ),
            additionalExpenses
        )}
    </SimpleList>
);

export default AdditionalExpensesList;
